import {t} from '../../../../i18n';

/**
 * 处理失败记录的错误消息国际化
 */
export interface FailedRecord {
    phone: string;
    errorMessage: string;
    messageKey?: string;
    details?: string | Record<string, any>; // GraphQL返回的是JSON字符串，需要解析
}

/**
 * 获取国际化的错误消息
 * @param record 失败记录
 * @returns 国际化后的错误消息
 */
export const getLocalizedErrorMessage = (record: FailedRecord): string => {
    // 如果有messageKey，尝试使用国际化
    if (record.messageKey) {
        // 解析details（可能是JSON字符串或对象）
        let detailsObj: Record<string, any> | undefined = undefined;
        if (record.details) {
            if (typeof record.details === 'string') {
                try {
                    detailsObj = JSON.parse(record.details);
                } catch (e) {
                    // 如果解析失败，忽略
                    console.warn('Failed to parse details JSON:', record.details, e);
                }
            } else {
                detailsObj = record.details;
            }
        }

        // 先尝试使用 .message 后缀（因为有些错误消息是嵌套对象结构）
        const messageKeyWithSuffix = `${record.messageKey}.message`;
        let message = t(messageKeyWithSuffix, detailsObj);

        // 如果 .message 后缀找不到翻译（返回的是 key 本身），尝试直接翻译 messageKey
        if (message === messageKeyWithSuffix) {
            message = t(record.messageKey, detailsObj);
            
            // 如果直接翻译也找不到，使用原始错误消息
            if (message === record.messageKey) {
                return record.errorMessage;
            }
        }

        return String(message);
    }

    // 没有messageKey，直接返回原始错误消息
    return record.errorMessage;
};
